import React from 'react';
import EsgDropdown from '../../components/EsgDropdown';
import Percent_Bars from '../../components/Percent_Bars';

const EsgPage2 = () => {
  return (
    <div className="bg-white">
      <div className="md:px-24 px-4 md:pt-7 pt-3">
      <h1 className='md:text-[36px] text-[10px] font-bold text-[#FDBD26]'>ENVIRONMENTAL SOCIAL & GOVERNANACE</h1>
        <p className='md:text-[36px] text-[8px] font-normal md:mb-8 mb-1 md:mt-4 mt-1'>
        Through the FarmNet app, farmers actively engage in Environmental, Social, and Governance (ESG) activities—promoting sustainable farming, strengthening community collaboration, and improving transparency. This not only supports climate resilience and ethical practices but also enhances farmer credibility with markets, investors, and development partners.
        </p>

        <div className="mx-auto flex  md:flex-row gap-1">
          {/* Environmental Participation */}
          <div className='w-full md:w-1/3'>
            <div className="bg-[#152C24] md:p-2  p-1 rounded mb-1">
              <h3 className="md:text-[16px] text-[6px] font-bold md:pl-5 text-[#FFFFFF] flex items-center">
              🌿 Environmental Participation
              </h3>
            </div>
            <div className="bg-[#2E453D] text-white md:p-4 p-2 md:pl-5 rounded-md border border-[#13483A] md:h-[350px]">
              <ul className="list-disc list-outside md:pl-6 pl-1 text-[5px] md:text-[15px] space-y-0">
                <li>
                  <strong>Climate-Smart Practices:</strong> FarmNet shares training and resources on conservation agriculture, organic input use, and agroforestry—helping farmers reduce their environmental footprint.
                </li>
                <li className=''>
                  <strong>Sustainable Resource Tracking:</strong> Farmers can log data on water usage, input application, and soil health<span className='md:flex hidden'>—promoting sustainable and traceable eco-friendly farming.</span>
                </li>
                <li  >
              <p  className='md:block hidden list-disc'>    <strong>Green Certification Support:</strong> The app can assist with data needed for sustainability certifications or climate finance programs (e.g., carbon credits or green supply chains).</p>
                </li>
              </ul>
            </div>
          </div>

          {/* Social Participation */}
          <div className='w-full md:w-1/3'>
            <div className="bg-[#152C24] md:p-2 p-1  rounded mb-1">
              <h3 className="md:text-[16px] text-[6px] text-white  font-bold  md:pl-5 flex items-center">
                🤝 Social Participation
              </h3>
            </div>
            <div className="bg-[#2E453D] text-white md:p-4 p-2 rounded-md border border-[#13483A] md:h-[350px]">
              <ul className="list-disc list-outside md:pl-6 pl-1 md:text-[15px] text-[5px] space-y-0">
                <li>
                  <strong>Inclusive Community Networks:</strong> FarmNet connects farmers into cooperatives and groups, promoting knowledge sharing, gender equity, and youth participation in agriculture.
                </li>
                <li>
                  <strong>Access to Services:</strong> Farmers get linked to health info, financial literacy training, and extension services <span className='md:flex hidden'>—contributing to overall community well-being.</span>
                </li>
                <li  >
          <p   className='md:block hidden' >      <strong>Transparency in Trade:</strong> The app facilitates fair trade by connecting farmers directly to markets, reducing exploitation and strengthening social justice.</p>
                </li>
              </ul>
            </div>
          </div>

          {/* Governance Participation */}
          <div className='w-full md:w-1/3'>
            <div className="bg-[#152C24] md:p-2 p-1 rounded mb-1">
              <h3 className="md:text-[16px] text-[6px] text-white  font-bold  md:pl-5 flex items-center">
                📊 Governance Participation
              </h3>
            </div>
            <div className="bg-[#2E453D] text-white md:p-4 p-2 rounded-md border border-[#13483A] md:h-[350px]">
              <ul className="list-disc list-outside md:pl-6 pl-1 text-[5px] md:text-[15px] space-y-0">
                <li>
                  <strong>Digital Records for Accountability:</strong> Farmers maintain transparent records of their practices and transactions, building trust with partners, buyers, and regulators.
                </li>
                <li>
                  <strong>Data-Driven Decision-Making:</strong> FarmNet empowers farmers to make smart choices using farm analytics,  <span className='md:flex hidden'>pricing data, and agronomic insights.</span>
                </li>
                <li>
            <p className='md:block hidden'>      <strong>Participation in Policy & Development Programs:</strong> With aggregated data, farmers can represent their interests better in discussions with development partners, NGOs, and government programs.</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      <h1 className='md:text-[36px] text-[10px] font-bold md:mt-11 mt-2 md:mb-5 text-[#FDBD26]'>ENVIRONMENTAL </h1>

        <div className="relative w-full h-[180px] md:h-[622px] rounded-[10px] overflow-hidden mb-6">
          <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745433617/image_24_km4uei.png" alt="Community" className="w-full h-full object-cover" />
          <div className="absolute bottom-4 md:bottom-8 left-4 md:left-16 text-white">
            <h2 className="font-bold text-[12px] md:text-[32px]">Grow Together , Thrive Together</h2>
            <p className="text-[10px] md:text-[24px]">“Connecting Namibian farmers to knowledge, tools, and each other.”</p>
          </div>
        </div>
      <h1 className='md:text-[40px] text-[10px] font-bold md:mt-10 md:mb-5 text-[#FDBD26]'>COMMUNITY </h1>

        <div className="md:mt-5 mt-2 max-w-screen-xl w-full">
            <div className="flex items-center gap-6 md:gap-8 text-[8px] md:text-[20px] font-normal text-black">
              <p>Story by Farmnet</p>
              <div className="flex items-center gap-2 text-[#155528]">
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743893169/Time_progress_light_ecbt3q.png"
                  alt="Clock"
                  className="h-3 w-3 md:h-8 md:w-8"
                />
                <p>28/04/2025</p>
              </div>
            </div>
          </div>
          <div className="text-black text-[14px] md:text-[30px] leading-relaxed">
          <h1 className=" text-black font-bold text-[12px] md:mt-5 md:text-[36px]">What are we looking for</h1>

  <p className="my-4 leading-tight">
    <strong className='font-extrabold'>🌍 1. Farmer Group Formation & Community Collaboration</strong><br />
    Farmers are organized into cooperatives or community-based groups through the app, promoting peer support, knowledge sharing, and collective action for improved <strong>livelihoods.</strong>
  </p>

  <p className="my-4  md:mt-8 mt-4  leading-tight" >
    <strong className='font-extrabold'>👩‍🌾 2. Inclusion of Women and Youth</strong><br />
    FarmNet encourages the participation of women and young farmers by providing tailored training, inclusive content, and access to input/market services, helping to build equity and empowerment in farming communities.
  </p>

  <p className="my-4 md:mb-6 md:mt-8 mt-4  leading-tight">
    <strong className='font-extrabold'>📚 3. Access to Training and Advisory Services</strong><br />
    The app delivers localized training modules, health and safety tips, and financial literacy content, equipping farmers with tools to make informed and responsible decisions that benefit their communities.
  </p>

  <p className="my-4 md:mb-6 md:mt-8 mt-4  leading-tight">
    <strong className='font-extrabold'>🤝 4. Fair Market Access</strong><br />
    By connecting farmers directly to trusted buyers, the app helps eliminate exploitation by middlemen, ensuring fair pricing, transparency, and economic justice for smallholders.
  </p>

  <p className="my-4 md:mb-11 md:mt-8 mt-4  leading-tight">
    <strong className='font-extrabold'>🧑‍⚖️ 5. Community-led Resource Management</strong><br />
    FarmNet facilitates coordinated use of shared assets like water points, tree nurseries, and storage facilities—promoting shared responsibility and sustainable local development.
  </p>
</div>

      <h1 className='md:text-[40px] text-[10px] font-bold md:mt-6 mt-2 md:mb-5 text-[#FDBD26]'>SUSTAINABILITY PRIORITIES </h1>
<EsgDropdown/>

<Percent_Bars/>
<div className="flex justify-between items-start md:mt-12 mt-3">
          <div></div> {/* Empty div to push the button to the right */}
<a href='/EsgPageMore2'>

<div>
            <div className="flex items-center ml-auto pr-3 md:pr-0 md:mb-1">
              <p className="md:text-[16px] text-[5px] bg-[#FFBD26] text-white px-2 md:px-4 md:w-[240px] md:py-[9px] py-[3px] md:rounded-tl-xl rounded-tl-md font-bold md:rounded-bl-xl rounded-bl-md whitespace-nowrap">
              VIEW MORE
              </p>
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745429488/Expand_right_4_yccnyz.png"
                alt="Expand"
                className="w-[20px] h-[5px] md:h-[42px] md:w-[55px] hidden md:flex object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl bg-[#152C24] px-2 md:py-2"
              />
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744370865/Expand_right_5_l2cjmf.png"
                alt="Expand"
                className="w-[20px] h-[13px] md:hidden flex py-[1px] md:h-[42.3px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#152C24] md:px-2 px-[2px] md:py-1"
              />
            </div>
            
          </div>
</a>
        </div>
<div className="flex justify-between  items-center border-b border-[#979797] md:mt-20 md:py-10  py-2 md:px-5 px-3 md:space-x-5 flex-wrap rounded-md shadow-lg">
        <div className="text-left text-xl sm:text-xl lg:text-2xl font-semibold">
          <h1 className='font-bold text-[10px] md:text-[32px] '>SDG No 13</h1>
          <h1 className="md:mt-3  -mt-4 text-[6px] md:text-[32px] font-medium">Take urgent action to combat climate change and its impacts</h1>
        </div>
        <div className="md:w-20">
          <img src='https://res.cloudinary.com/dzngpgki4/image/upload/v1745280679/image_44_ircbsd.png' alt="Climate Action" className="md:w-full md:h-auto w-[20px] h-[20px]" />
        </div>
      </div>
      <div className='md:h-5 h-2'></div>
      </div>
    </div>
  );
};

export default EsgPage2;
